export function PushNotificationGuide() {
	return (
		<div className=" p-6 bg-card">
			<div className="space-y-6">
				{/* Step 1 */}
				<div>
					<h4 className="text-lg font-medium mb-2">
						1. Navigate to Notification Center
					</h4>
					<p className="text-sm text-muted-foreground">
						Click on <span className="font-semibold">"Push Notifications"</span>{" "}
						in the side navigation menu to access the Notification Center. This
						page displays all notifications you've created, sorted from newest
						to oldest.
					</p>
				</div>

				{/* Step 2 */}
				<div>
					<h4 className="text-lg font-medium mb-2">
						2. Create a New Notification
					</h4>
					<p className="text-sm text-muted-foreground mb-3">
						Click the{" "}
						<span className="font-semibold">"Create Notification"</span> button
						to open the notification creation form.
					</p>
					<div className="ml-4 space-y-2">
						<div>
							<p className="text-sm font-medium">Heading</p>
							<p className="text-sm text-muted-foreground">
								The main title displayed in the push notification on users'
								devices. Keep it concise and attention-grabbing.
							</p>
						</div>
						<div>
							<p className="text-sm font-medium">Sub Heading</p>
							<p className="text-sm text-muted-foreground">
								The secondary text displayed in the push notification. This
								appears below the heading in the notification preview.
							</p>
						</div>
						<div>
							<p className="text-sm font-medium">Content</p>
							<p className="text-sm text-muted-foreground">
								The full message displayed when users open the notification in
								the app. This field supports{" "}
								<span className="font-semibold">rich text formatting</span>{" "}
								including bold, italics, lists, and links. Use this to provide
								detailed information about your announcement or event.
							</p>
						</div>
						<div>
							<p className="text-sm font-medium">Urgency</p>
							<p className="text-sm text-muted-foreground italic">
								Note: This field is not currently used by the system and can be
								ignored.
							</p>
						</div>
					</div>
				</div>

				{/* Step 3 */}
				<div>
					<h4 className="text-lg font-medium mb-2">
						3. Send Your Notification
					</h4>
					<p className="text-sm text-muted-foreground mb-3">
						After creating your notification, click the{" "}
						<span className="font-semibold">"View"</span> button next to the
						notification you want to send. This will open the notification
						details page where you'll find the send buttons.
					</p>
					<p className="text-sm text-muted-foreground mb-3">
						You have two sending options:
					</p>
					<div className="ml-4 space-y-3">
						<div>
							<p className="text-sm font-medium">Test Send</p>
							<p className="text-sm text-muted-foreground">
								Send the notification only to devices marked as test devices.
								Use this to preview how the notification will appear before
								sending to all users.
								<span className="block mt-1 font-semibold">
									Important: Once sent, only test users will be able to see this
									notification in the app.
								</span>
								This allows you to verify the formatting and content before
								broadcasting to everyone.
							</p>
						</div>
						<div>
							<p className="text-sm font-medium">Production Send</p>
							<p className="text-sm text-muted-foreground">
								Send the notification to all registered users with notifications
								enabled. Use this when you're ready to broadcast your message.
								<span className="block mt-1 font-semibold">
									Important: Once sent, all users will be able to see this
									notification in their app.
								</span>
								Make sure you've tested the notification first to ensure proper
								formatting and content.
							</p>
						</div>
					</div>
				</div>

				{/* Best Practices */}
				<div className="border-t pt-4">
					<h4 className="text-lg font-medium mb-2">Best Practices</h4>
					<ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground ml-2">
						<li>Always test your notification before sending to production</li>
						<li>
							Keep headings under 50 characters for best display on mobile
							devices
						</li>
						<li>
							Use the content field for detailed information - don't cram
							everything into the heading
						</li>
						<li>
							Review your notification for typos and formatting before sending
						</li>
						<li>
							Consider the timing of your notifications to maximize engagement
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
